module.exports = __webpack_public_path__ + "static/media/IMG_3302.00d90f7c.jpg";